import { Component, Input } from '@angular/core';

@Component({
  selector: 'stars',
  template: `
    <mat-icon *ngFor="let i of [1, 2, 3, 4, 5]">
      {{ stars >= i ? 'star' : 'star_border' }}
    </mat-icon>
  `,
  styles: [`
    .mat-icon {
      font-size: 15px !important;
      height: 15px !important;
      width: 15px !important;
      min-height: 15px !important;
      min-width: 15px !important;
      display: inline-block !important;
      color: #ffb508;
    }
  `]
})
export class StarsComponent {
  @Input() stars: Number;
}
